<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#FFDA7E">
    <path d="M15.3327 4L8.99935 10.3333L5.66602 7L0.666016 12" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M11.334 4H15.334V8" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
